import { Chip } from "ui/chip";

type ThemeStatusIndicatorProps = {
  applyClientTheme?: boolean;
};

const ThemeStatusIndicator = ({ applyClientTheme }: ThemeStatusIndicatorProps) => {
  const isThemed = applyClientTheme === true;

  return (
    <div className="flex shrink-0 flex-col items-start justify-center text-sm">
      <span className="font-normal text-gray-500">Theme status</span>
      <Chip
        sx={{ textTransform: "none" }}
        size="small"
        variant="outlined"
        color={isThemed ? "success" : "default"}
        label={isThemed ? "Applied" : "Not applied"}
      />
    </div>
  );
};

export default ThemeStatusIndicator;
